module.exports = __webpack_public_path__ + "img/adv-mapIcon211.3c1b198d.png";